import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ButtonBar from '../ButtonBar';

export const displayName = 'DismissibleButtonBar';

export class DismissibleButtonBar extends PureComponent {
  static propTypes = {
    getRef: PropTypes.func,
    children: PropTypes.node,
  };

  static defaultProps = {
    getRef: Function.prototype,
  };

  render() {
    const { children, ...props } = this.props;

    return (
      <ButtonBar {...props} ref={this.props.getRef}>
        {children}
      </ButtonBar>
    );
  }
}

const StyledDismissibleButtonBar = styled(DismissibleButtonBar)``;

StyledDismissibleButtonBar.displayName = displayName;

export default StyledDismissibleButtonBar;
